import moment from 'moment'

export default class UnmappedDomain {

    zoneId
    recordId
    record
    domain
    sysUserId
    dnsLastUpdate

    static fromObject(o) {
        if (typeof o['zoneId'] !== 'number') {
            throw new Error('Missing field zoneId for UnmappedDomain.')
        }
        if (typeof o['recordId'] !== 'number') {
            throw new Error('Missing field recordId for UnmappedDomain.')
        }
        if (typeof o['record'] !== 'string') {
            throw new Error('Missing field record for UnmappedDomain.')
        }
        if (typeof o['domain'] !== 'string') {
            throw new Error('Missing field domain for UnmappedDomain.')
        }
        if (typeof o['sysUserId'] !== 'number') {
            throw new Error('Missing field sysUserId for UnmappedDomain.')
        }
        if (typeof o['dnsLastUpdate'] !== 'string') {
            throw new Error('Missing field dnsLastUpdate for UnmappedDomain.')
        }

        try {
            const ud = new UnmappedDomain()
            ud.zoneId = o['zoneId']
            ud.recordId = o['recordId']
            ud.record = o['record']
            ud.domain = o['domain']
            ud.sysUserId = o['sysUserId']
            ud.dnsLastUpdate = moment(o['dnsLastUpdate']).utc()
            return ud
        } catch (e) {
            throw new Error(`Failed to create UnmappedDomain from object: ${e}`)
        }
    }

    getFqdn() {
        return this.record !== '' ? `${this.record}.${this.domain}` : this.domain
    }

}